/* src/app/modules/spare-parts/service-parts/service-parts.component.scss */
:host {
  display: block;
  overflow-x: auto;
}
.part-description-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ticket-number {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.4rem;
  align-items: center;
}
.ticket-number sh-icon {
  visibility: hidden;
  cursor: pointer;
}
.ticket-number:hover {
  text-decoration: underline;
}
.ticket-number:hover sh-icon {
  visibility: visible;
}
sh-table {
  min-width: fit-content;
  width: 100%;
}
.table-height {
  height: 22rem;
}
/*# sourceMappingURL=service-parts.component.css.map */
